var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-callout-dismisser',{attrs:{"feature-name":"security_training_feature_promotion"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var dismiss = ref.dismiss;
var shouldShowCallout = ref.shouldShowCallout;
return [(shouldShowCallout)?_vm._t("default",null,null,{
        dismiss: dismiss,
        buttonLink: _vm.buttonLink,
        buttonText: _vm.$options.i18n.buttonText,
        trackCTAClick: _vm.trackCTAClick,
      }):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }